<template>
  <div>
    <v-select
        :searchable="search"
        :reduce="reduce"
        :label="label"
        :options="options"
        :clearable="false"
        :value="value"
        @input="$emit('input', $event)"
        :placeholder="placeholder"
        :loading="loading"
        :class="no_border ? 'v-no' : ''"
        :multiple="multiple"
    >
      <template #open-indicator="{ attributes }">
        <img src="../assets/img/main/open.svg" v-bind="attributes"/>
      </template>
      <template #no-options="{ search, searching }">
        {{searching ? `По запросу "${search} ничего не найдено"` : 'Извините, совпадений не найдено.'}}
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "app-select",
  props:{
    label: {
      type: String,
      default: "label"
    },
    reduce: {
      type: Function,
      default: option => option,
    },
    value: {
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    no_border: {
      type: Boolean,
      default: false
    },
    selected: null,
    placeholder: null,
  },
}
</script>

<style >
.v-select {
  display: flex !important;
  justify-content: space-between !important;
  min-height: 40px;
  padding: 0 5px 0 5px;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: white;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  margin-bottom: 15px;
}
.v-no {
  height: unset;
  border: unset;
  background-color: transparent;
  margin: unset;
}

/*.v-no .vs__search {*/
/*  display: none;*/
/*}*/

.vs--open{
  border-color: #2CB181;
}

.vs__dropdown-toggle{
  border: unset !important;;
  width: 100%;
}

.style-chooser .vs__dropdown-menu {
  margin-top: 5px;
  box-shadow: 2px 3px 5px rgba(0,0,0,0.1);
}

.vs__open-indicator {
  width: 9px;
}

.vs__dropdown-menu {
  max-height: 210px;
}

.vs__search, .vs--searchable .vs__dropdown-toggle {
  cursor: default;
}
</style>
